import type { AdminPnlTopBarProps } from "../../models/admin-pnl.models";

const AdminPnlTopBar = ({ filters, reviewers, rowCount, disabled, onFilters, onSearch }: AdminPnlTopBarProps) => (
  <form
    data-test="admin-pnl-top-bar"
    className="flex flex-none flex-wrap items-center gap-3 border-b border-gray-200 bg-white px-3 py-2 dark:border-gray-700 dark:bg-gray-800"
    onSubmit={(event) => {
      event.preventDefault();
      if (!disabled) onSearch();
    }}
  >
    <h1 className="text-sm font-semibold">Voyage PnL support</h1>
    <span className="text-xs opacity-70">{rowCount} voyages</span>
    <label className="flex items-center gap-2 text-xs">
      <span>Reviewer</span>
      <select
        aria-label="PnL reviewer"
        data-test="admin-pnl-reviewer"
        value={filters.reviewerEmail}
        disabled={disabled}
        onChange={(event) => onFilters({ ...filters, reviewerEmail: event.target.value })}
        className="h-8 max-w-full border border-gray-300 bg-transparent px-2 text-sm dark:border-gray-600 dark:bg-gray-800"
      >
        <option value="">Choose a reviewer</option>
        {reviewers.map((reviewer) => (
          <option key={reviewer.EMAIL} value={reviewer.EMAIL}>
            {reviewer.NAME || reviewer.EMAIL}
          </option>
        ))}
      </select>
    </label>
    <label className="ml-auto flex items-center gap-2 text-xs">
      <span>Search</span>
      <input
        type="search"
        aria-label="Search PnL voyages"
        data-test="admin-pnl-search"
        maxLength={100}
        placeholder="Vessel, code, IMO, contract or voyage"
        value={filters.search}
        disabled={disabled}
        onChange={(event) => onFilters({ ...filters, search: event.target.value })}
        className="h-8 w-72 max-w-full border border-gray-300 bg-transparent px-2 text-sm dark:border-gray-600"
      />
    </label>
    <button
      type="submit"
      disabled={disabled}
      data-test="admin-pnl-refresh"
      className="h-8 border border-gray-300 px-3 text-xs font-semibold text-green hover:bg-[#E9F4F3] disabled:opacity-50 dark:border-gray-600"
    >
      Search / refresh
    </button>
  </form>
);

export default AdminPnlTopBar;
